var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { loading: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "fixedButton", staticStyle: { "margin-top": "10px" } },
      [
        _c(
          "vxe-button",
          { staticClass: "examineButton", on: { click: _vm.ReturnFun } },
          [_vm._v("返回")]
        ),
        _c(
          "vxe-button",
          {
            staticClass: "examineButton",
            attrs: { status: "primary" },
            on: {
              click: function ($event) {
                return _vm.submint()
              },
            },
          },
          [_vm._v("保存")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "CertificateReleaseApplicationBox scrollBars ActivityPlanReviewExamine",
        style: "height:" + (_vm.$store.state.app.height - 70) + "px;",
      },
      [
        _c("activityInformation", {
          attrs: {
            data: _vm.activity,
            disabled: true,
            "special-budget": _vm.specialBudgetFlag,
          },
        }),
        _c("registerInformation", {
          ref: "registerInformation",
          attrs: {
            data: _vm.signData,
            activity: _vm.activity,
            "file-list": _vm.fileList,
            "disabled-edit": !_vm.specialBudgetFlag,
          },
          on: {
            "update:fileList": function ($event) {
              _vm.fileList = $event
            },
            "update:file-list": function ($event) {
              _vm.fileList = $event
            },
            setStrainsJingArr: _vm.setStrainsJingArr,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }